import React from "react"
import '../../src/Styling/Layout.css'


const ThankYouComponent = (props) => {
  return (
    <div>

     
      <h1 > Thank you for your purchase.Please attend the class with the meeting link on your mail.</h1>
      <h1 > Thank you for your purchase.Please attend the class with the meeting link on your mail.</h1>

     
      <h1 > Thank you for your purchase.Please attend the class with the meeting link on your mail.</h1>
      <h1 > Thank you for your purchase.Please attend the class with the meeting link on your mail.</h1>
      


    </div>
  )
};

export default ThankYouComponent;

